<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <PageTitle v-bind:title="title" v-bind:admin="false" />


    <ErrorMessage
      v-if="errors.load"
      :error="errors.load"
      class="max-w-sm mx-auto"
    />
    <ErrorMessage
      v-if="errors.startTesting"
      :error="errors.startTesting"
      class="max-w-sm mx-auto"
    />
    <ErrorMessage
      v-if="errors.finishTesting"
      :error="errors.finishTesting"
      class="max-w-sm mx-auto"
    />
    <ErrorMessage
      v-if="errors.send"
      :error="errors.send"
      class="max-w-sm mx-auto"
    />

    <div v-if="errors.timeisup">
      <ErrorMessage
        :error="errors.timeisup"
        class="max-w-sm mx-auto"
      />
      <div class="mt-5 sm:mt-4 text-center ">
        <span class="font-bold">
          Вы можете вернуться к 
          <router-link class="text-indigo-500 underline" :to="{ name: 'chapter_show', params: { id: data.chapter.id } }">&nbsp;Главе,</router-link>
          &nbsp; или перейти к &nbsp;
          <router-link class="text-indigo-500 underline" :to="{ name: 'course_show', params: { id: data.chapter.course_id } }">списку Глав.</router-link>
        </span>
      </div>
    </div>

    <ModalTestingResults v-bind:data="ModalData"  />
    <div v-if="loading">
      <!-- если время истекло, то Loader не показываем: -->
      <Loader v-if="!errors.timeisup" />
    </div>
    <div v-else>

      <div class="mt-8">
        <p>
          <span class="text-lg leading-6 font-medium text-gray-900">Курс:</span>
          <router-link
            :to="{ name: 'course_show', params: { id: data.course.id } }"
            class="ml-2 bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >{{ data.course.name }}</router-link
          >
        </p>
        <p class="mt-2">
          <span class="text-lg leading-6 font-medium text-gray-900"
            >Глава:</span
          >

          <router-link
            :to="{ name: 'chapter_show', params: { id: data.chapter.id } }"
            class="ml-2 bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >{{ data.chapter.name }}</router-link
          >
        </p>
      </div>

      <div v-if="!data.testing" class="rounded-md shadow mr-4">
        <button
          @click.prevent="startTesting"
          class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
          type="button"
        >
          Начать Тестирование
        </button>
      </div>
      <div v-else>
        <SuccessMessage
          :msg="'Тестирование активно'"
          class="max-w-sm mx-auto"
        />
        <div class="text-3xl text-center px-4 py-2 my-4 text-green-700 rounded-lg">
          <CurrTimer v-bind:x="data.testing.seconds" @time-is-up="timeIsUp" />
        </div>

        <div class="prose text-center prose-indigo text-gray-500 mx-auto lg:max-w-none">
          Введите ответы на все вопросы и нажмите "Завершить тестирование".
        </div>



        <div class="flex flex-col my-16">
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
            >
              <Loader v-if="loading_exams" />
              <div
                v-if="!loading_exams"
                class=" overflow-hidden sm:rounded-lg"
              >


                <div v-for="exam in data.exams" v-bind:key="exam.id">

                  <div v-if="exam.id == curr_exam_id">

                    <div class="bg-white sm:rounded-lg mt-8">
                      <div class="px-4 py-5 sm:p-6">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                          {{ exam.name }}
                        </h3>
                        <div class="mt-2 max-w-xl text-gray-500">
                          <p v-html="exam.text"></p>
                        </div>
                      </div>
                    </div>



                    <h4 class="mt-4 mb-4 text-lg">Варианты ответа:</h4>
                    <div>
                      <div class="ml-2 mt-4 sm:mt-0 sm:col-span-2">
                        <div class="max-w-lg space-y-4">
                          <div v-for="solut in exam.solutions" :key="solut.id">
                            <div class="relative flex items-start">
                              <div class="flex items-center h-5">
                                <input
                                  type="checkbox"
                                  :name="'answer' + solut.id"
                                  :id="'answer' + solut.id"
                                  v-model="solut.useranswer"
                                  class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                              </div>
                              <div class="ml-3 text-sm">
                                <label
                                  :for="'answer' + solut.id"
                                  class="font-medium text-gray-700"
                                  >{{ solut.text }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="(curr_exam_index + 1) < data.exams.length">
                      <button
                        @click.prevent="nextExam(false)"
                        class="font-medium rounded-lg py-1 px-2 bg-green-600 text-white hover:bg-green-700 mt-4 ml-4"
                        type="button"
                      >
                        Следующий вопрос
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <button
          v-if="(curr_exam_index + 1) == data.exams.length"
          @click.prevent="nextExam(true)"
          class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700"
          type="button"
        >
          Завершить Тестирование и посмотреть результат
        </button>
        <button
          @click.prevent="breakTesting"
          class="mt-4 w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-500 hover:bg-red-500"
          type="button"
        >
          Прервать тестирование
        </button>

      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import BreadCrumbs from "@/components/BreadCrumbs";
import ErrorMessage from "@/components/ErrorMessage";
import SuccessMessage from "@/components/SuccessMessage";
import PageTitle from "@/components/PageTitle";
import CurrTimer from "@/components/CurrTimer";
import ModalTestingResults from "@/components/ModalTestingResults_2";
// import ChapterMarkAndFinish from "@/components/ChapterMarkAndFinish";
//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      loading_exams: false,
      data: [],
      id: 0,
      curr_exam_id: null,
      curr_exam_index: null,
      name: "",
      errors: { load: "", startTesting: '', finishTesting: '', send: '', timeisup: '' },
      title: "Тестирование",
      bcrumbs: [],
      ModalData: {
        id: 0,
        caption: "",
        message: "",
        show: false,
        style: "",
        okCaption: "Удалить!",

        exams_qnt: null,
        exams_done: null,
        grade: null,
        grade_prev: null,
        is_chapter_closed: null,
        is_grade_updated: null,
        chapter_status: null,
      },
    };
  },
  async mounted() {
    this.loadRecords();
  },
  //
  // Если тестирование активно, то при переходе куда-то, будем это тестирование прерывать.
  //
  async beforeRouteLeave(to, from, next) {
    if (!this.data.testing) {
      next(true)
      return
    }
    if (!confirm('Прервать тестирование и перейти?')) return;
    this.errors.breakTesting = "";
    try {
      let response = await axios.post(
        "chapters/" + this.$route.params.id + "/BreakTesting"
      );
      if (response.status == 200) {
        this.loading = true;
        next(true);
      }
    } catch (e) {
      if (e.response.status == 520) {
        this.errors.breakTesting = e.response.data.error;
      } else {
        this.errors.breakTesting = "Неизвестная ошибка при прерывании Тестирования.";
      }
    }
  },


  methods: {

    timeIsUp()
    {
      this.loading = true
      this.errors.timeisup = 'Время, отведённое на тестирование, истекло.'
    },

    //
    // Перейти к следующему вопросу.
    //
    nextExam(andFinishTesting=false)
    {
      this.errors.send = "";
      if (this.curr_exam_index + 1 <= this.data.exams.length)
      {
        var tmp = this.data.exams[this.curr_exam_index].solutions.find(solut => solut.useranswer === true)
        if (tmp || confirm("Не выбрано ни одного варианта ответа. Вы уверены что хотите продолжить?"))
        {
          this.loading_exams = true
          this.giveAnswer(andFinishTesting)
        }
      }
    },

    //
    // Сохранить (отправить) ответ на текущий вопрос, и (опционально) завершить тестирование.
    //
    async giveAnswer(andFinishTesting=false)
    {
      this.errors.send = "";
      try {
        this.loading_exams = true
        let response = await axios.post(
          "exams/" + this.curr_exam_id + "/giveAnswer",
          Object.assign({solutions: this.data.exams[this.curr_exam_index].solutions, _method: "PUT" })
        );
        if (response.status == 200) {
          if (andFinishTesting) 
          {
            console.log('начали завершать тестирование...')
            this.finishTesting()
          }
          else
          {
            this.curr_exam_index ++;
            this.curr_exam_id = this.data.exams[this.curr_exam_index].id;
            this.loading_exams = false
          }
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.send = e.response.data.error;
        } 
        else if (e.response.status == 521) {
          this.loading = true
          this.errors.timeisup = e.response.data.error;
        }
        else {
          this.errors.send = "Неизвестная ошибка при отправке ответа.";
        }
      }
    },


    async loadRecords() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "chapters/" + this.$route.params.id + "/testing"
        );
        this.data = response.data;
        this.bcrumbs = response.data.bcrumbs;
        if (this.data.exams.length)
        {
          this.curr_exam_id = this.data.exams[0].id;
          this.curr_exam_index = 0;
        }
        this.loading = false;
      } catch (e) {
        if (e.response.status == 401) {
          this.errors.load = e.response.data.error;
        } else {
          this.errors.load = "Ошибка при загрузке данных";
        }
      }
    },



    //
    // Начать тестирование.
    //
    async startTesting() {
      this.errors.startTesting = "";
      try {
        let response = await axios.post(
          "chapters/" + this.$route.params.id + "/StartTesting"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadRecords();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.startTesting = e.response.data.error;
        } else {
          this.errors.startTesting = "Неизвестная ошибка при старте Тестирования.";
        }
      }
    },

    //
    // Прервать тестирование.
    //
    async breakTesting() {
      this.errors.breakTesting = "";
      if (!confirm('Прервать тестирование?')) return;
      try {
        let response = await axios.post(
          "chapters/" + this.$route.params.id + "/BreakTesting"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadRecords();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.breakTesting = e.response.data.error;
        } else {
          this.errors.breakTesting = "Неизвестная ошибка при прерывании Тестирования.";
        }
      }
    },


    //
    // Завершить тестирование.
    //
    async finishTesting() {
      this.errors.finishTesting = "";
      try {
        let response = await axios.post(
          "chapters/" + this.data.chapter.id + "/FinishTesting"
        );
        if (response.status == 200) {
          this.loading = true;         
          this.ModalData.exams_qnt = response.data.exams_qnt;
          this.ModalData.exams_done = response.data.exams_done;
          this.ModalData.grade = response.data.grade;
          this.ModalData.grade_prev = response.data.grade_prev;
          this.ModalData.is_chapter_closed = response.data.is_chapter_closed;
          this.ModalData.is_grade_updated = response.data.is_grade_updated;
          this.ModalData.chapter_status = response.data.chapter_status;
          this.ModalData.course_id = response.data.course_id;
          this.ModalData.next_chapter = response.data.next_chapter;
          this.data.testing = null;
          this.ModalData.show = true;         
          //this.loadRecords();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.finishTesting = e.response.data.error;
        } else {
          this.errors.finishTesting = "Неизвестная ошибка при завершении Тестирования.";
        }
      }

    },



  },


/*
  computed: {
    progress() {
      return Math.round(
        (100 * this.data.questions_finished_count) / this.data.questions_count
      );
    },
  },
*/
  components: {
    Loader,
    BreadCrumbs,
    PageTitle,
    ErrorMessage,
    SuccessMessage,
    CurrTimer,
    ModalTestingResults,
    // ChapterMarkAndFinish,
  },
};
</script>


<style scoped>
.custom-table {
  width: 100%;
  overflow: hidden;
  border-collapse: collapse;
  border-radius: 30px;
  border-radius: 10px;
  box-shadow: 0 0 2px 1px #e4e7eb;
}

.custom-table__col--10 {
  width: 10%;
}

.custom-table__col--25 {
  width: 25%;
}

.custom-table__col--50 {
  width: 50%;
}

.custom-table__col--75 {
  width: 75%;
}

.custom-table__header {
  border-radius: 10px;
  background-color: #f5f7fa;
}
.custom-table__header th {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 0.8rem;
  color: #166086;
}

.custom-table th,
.custom-table td {
  padding: 15px 20px;
  border-bottom: 1px solid hsl(214, 15%, 91%);
}
</style>